import {
    Container,
    ContainerAvatar,
    ContainerData,
    ContentLineClamp,
    ContentName,
} from "./styled";
import {Tooltip} from "antd";

import AvatarImage from "@dropDesk/presentation/components/avatar";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";

const InternalChatUserList = (
    {
        internalChatUser,
        searchParam,
        maxWidthContainer
    }: {
        internalChatUser: InternalChatUserEntity
        searchParam: string,
        maxWidthContainer: number
    }
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const containerAvatarWidth = 70;
    const containerThreeDots = 22;
    const containerLineClampName = maxWidthContainer - containerAvatarWidth - containerThreeDots;
    const name = internalChatUser.user?.name ?? '';
    const email = internalChatUser.user?.email ?? '';

    return (
        <Container
            background={colors.onBackground}
            isDarkenBackground={false}
        >
            <ContainerAvatar width={containerAvatarWidth}>
                <AvatarImage
                    useCursorPointer={false}
                    title={name}
                    size={49}
                    round={true}
                    hasPreviewImage={false}
                    withBorder={true}
                    letterSize={18}
                />
            </ContainerAvatar>
            <ContainerData bordercolor={colors.border}>

                <ContentName>
                    <ContentLineClamp color={colors.text} height={25} width={containerLineClampName}>
                        <Tooltip placement="topLeft" title={name}>
                            <>
                                <HighLightWords
                                    searchWords={searchParam}
                                    textToHighlight={name}
                                />
                            </>
                        </Tooltip>
                    </ContentLineClamp>
                    <ContentLineClamp color={colors.hintInverse} height={25} width={containerLineClampName}>
                        <Tooltip placement="topLeft" title={email}>
                            <>
                                <HighLightWords
                                    searchWords={searchParam}
                                    textToHighlight={email}
                                    color={colors.hintInverse}
                                />
                            </>
                        </Tooltip>
                    </ContentLineClamp>
                </ContentName>
            </ContainerData>
        </Container>
    )
}
export default InternalChatUserList;
